import { render, staticRenderFns } from "./productCategoriesIndex.vue?vue&type=template&id=d498d01a&"
import script from "./productCategoriesIndex.vue?vue&type=script&lang=js&"
export * from "./productCategoriesIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports